import { motion, useReducedMotion } from "framer-motion";

const SectionHeading = ({ eyebrow, title, sub, testId }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      data-testid={testId}
      initial={reduce ? false : { opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="mx-auto max-w-2xl text-center"
    >
      <span className="inline-flex items-center rounded-full border border-line bg-white px-4 py-1.5 text-xs font-semibold text-sage-deep">
        {eyebrow}
      </span>
      <h2 className="font-display mt-5 text-3xl font-bold text-charcoal sm:text-4xl lg:text-5xl">
        {title}
      </h2>
      {sub && (
        <p className="mt-4 text-base leading-relaxed text-graphite/70 md:text-lg">{sub}</p>
      )}
    </motion.div>
  );
};

export default SectionHeading;
